var SupplierLogger = {};
SupplierLogger.log = function(supplierId, message, strategy) {
  var data = { message: message };
  if(typeof(strategy) !== 'undefined') data.strategy = strategy;
  fetch('/rest/v2/actionLogEntry/' + supplierId, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json'
    }
  })
};

export {SupplierLogger};
